// ============================================
// GWP Cart Script — Haarspullen.nl
// ============================================

if (window.Shopify && window.Shopify.market && window.Shopify.market.handle !== 'nl') {
  throw new Error('GWP: niet-NL markt, script gestopt.');
}

var GWP_CAMPAIGNS = [
  { active: false, tag: 'gwp-wella-eimi',          giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { active: false, tag: 'gwp-kms',                 giftVariantId: '57720099766646', giftHandle: 'therma-shape-quick-blow-dry-75ml' },
  { active: false,  tag: 'gwp-indola-hairpin',      giftVariantId: '57676128715126', giftHandle: 'indola-hairpin' },
  { active: true,  tag: 'gwp-ghd-toolbag',         giftVariantId: '56519708279158', giftHandle: 'ghd-tool-bag' },
  { active: false,  tag: 'gwp-blondme-set',         giftVariantId: '57794776072566', giftHandle: 'schwarzkopf-comb-mirror-set' },
  { active: false,  tag: 'gwp-maniac-topcoat',      giftVariantId: '56590815363446', giftHandle: 'maniac-top-coat-shine' },
  { active: false,  tag: 'gwp-gladskin-lipbalm',    giftVariantId: '57794984542582', giftHandle: 'everyday-lip-balm-spf30' },
{ active: true, tag: 'gwp-hairtowel', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 2 },
{ active: true, tag: 'gwp-hairtowel-sets', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 1 },
  { active: false,  tag: 'gwp-sebastian-kaars',     giftVariantId: '57798933315958', giftHandle: 'sebastian-dark-oil-geurkaars' },
  { active: false,  tag: 'gwp-mediceuticals-comb',  giftVariantId: '57728046268790', giftHandle: 'mediceuticals-scalpro-brush-buddy-comb-cleanser' },
  { active: false,  tag: 'gwp-olaplex-set',         giftVariantId: '57863213580662', giftHandle: 'olaplex-no-5-leave-in-travelsize' },
  { active: true, tag: 'gwp-bc-sunprotect',       giftVariantId: '57972553515382', giftHandle: 'bc-sun-beach-towel', minTaggedCount: 2 },
  { active: false, tag: 'gwp-blondme-towel',       giftVariantId: '56414070309238', giftHandle: 'schwarzkopf-hair-towel-wit' },
  { active: false, tag: 'gwp-tee-shampoo', giftVariantId: '57265067426166', giftHandle: 'schwarzkopf-fibre-clinix-hydrate-shampoo' },
{ active: false, tag: 'gwp-janzen-men', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 3 },
{ active: false, tag: 'gwp-janzen-set', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 1 },
{ active: false, tag: 'gwp-beachbag', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 2 },
{ active: false, tag: 'gwp-beachbag-set', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 1 },
{ active: true, tag: 'gwp-janzen-mist', giftVariantId: '58111784780150', giftHandle: 'body-mist-c-bergamot-fig-breeze-mini', minTaggedCount: 2 },
  { active: true, tag: 'gwp-attitude-spf', giftVariantId: '56327786955126', giftHandle: 'attitude-lip-balm-plastic-free', minTaggedCount: 2 },
{ active: true, tag: 'gwp-indola-beachbag', giftVariantId: '58095376400758', giftHandle: 'indola-beach-bag' },
{ active: false, tag: 'gwp-heatless-curls', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 3 },
{ active: false, tag: 'gwp-heatless-curls-sets', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 1 },
{ active: false, tag: 'gwp-bc-pouch', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 2 },
{ active: false, tag: 'gwp-bc-pouch-sets', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 1 },
{ active: false, tag: 'gwp-goldwell-bondisands', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 3 },
{ active: false, tag: 'gwp-goldwell-bondisands-sets', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 1 },
{ active: false, tag: 'gwp-kis-color', giftVariantId: '56414072602998', giftHandle: 'kis-protecting-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-curlsmith', giftVariantId: '56327509901686', giftHandle: 'curl-smith-essential-moisture-conditioner', minTaggedCount: 1 },
{ active: true, tag: 'gwp-weleda', giftVariantId: '58148956701046', giftHandle: 'weleda-skin-food-creme', minTaggedCount: 1 },
{ active: true, tag: 'gwp-biosilk', giftVariantId: '56974786068854', giftHandle: 'biosilk-therapy-conditioner', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wellaset', giftVariantId: '56327675216246', giftHandle: 'wella-ultimate-repair-masker', minTaggedCount: 1 },
{ active: false, tag: 'gwp-milkshake', giftVariantId: '56414076240246', giftHandle: 'lipgloss-caramel-brown', minTaggedCount: 1 },
{ active: true, tag: 'gwp-stmnt-grooming', giftVariantId: '58200831066486', giftHandle: 'stmnt-fiber-pomade', minTaggedCount: 2 },
{ active: true, tag: 'gwp-stmnt-grooming-sets', giftVariantId: '58200831066486', giftHandle: 'stmnt-fiber-pomade', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wella-fusion', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-wella-fusion-sets', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 1 },
{ active: true, tag: 'gwp-nioxin-kits', giftVariantId: '58393739067766', giftHandle: 'nioxin-pouch-gift', minTaggedCount: 1 },
{ active: true, tag: 'gwp-blondme-mini', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 2 },
{ active: true, tag: 'gwp-blondme-mini-sets', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 1 },
{ active: true, tag: 'gwp-indola-curls-sets', giftVariantId: '58411712086390', giftHandle: 'indola-curl-defining-brush', minTaggedCount: 1 },
];

// ============================================
// Logica — niet aanpassen
// ============================================

var gwpRunning = false;
var gwpFetching = false;

function gwpGetCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}

function gwpAddToCart(variantId) {
  gwpFetching = true;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gwp: 'true' } }),
  }).finally(function() { gwpFetching = false; });
}

function gwpRemoveFromCart(variantId) {
  gwpFetching = true;
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  }).finally(function() { gwpFetching = false; });
}

async function gwpIsGiftAvailable(handle, variantId) {
  try {
    var res = await fetch('/products/' + handle + '.js');
    var product = await res.json();
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i].available;
      }
    }
    return false;
  } catch(e) { return false; }
}

// Cache voor product tags — voorkomt dubbele fetches
var productTagCache = {};
async function gwpGetProductTags(handle) {
  if (productTagCache[handle]) return productTagCache[handle];
  try {
    var res = await fetch('/products/' + handle + '.js');
    var product = await res.json();
    productTagCache[handle] = product.tags || [];
    return productTagCache[handle];
  } catch(e) { return []; }
}

async function updateGWP() {
  if (gwpRunning) return;
  gwpRunning = true;
  productTagCache = {};

  try {
    var cart = await gwpGetCart();

    // Bouw een map: giftVariantId -> { campaigns, giftHandle }
    var giftMap = {};
    for (var i = 0; i < GWP_CAMPAIGNS.length; i++) {
      var camp = GWP_CAMPAIGNS[i];
      if (!camp.active) continue;
      var vid = String(camp.giftVariantId);
      if (!giftMap[vid]) giftMap[vid] = { campaigns: [], giftHandle: camp.giftHandle };
      giftMap[vid].campaigns.push(camp);
    }

    // Bereken taggedCount per campagne in één pass over de cart
    var tagCounts = {};
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      var tags = await gwpGetProductTags(item.handle);
      for (var vid in giftMap) {
        var campaigns = giftMap[vid].campaigns;
        for (var c = 0; c < campaigns.length; c++) {
          var tag = campaigns[c].tag;
          if (!tagCounts[tag]) tagCounts[tag] = 0;
          // Skip als dit item een GWP cadeau is (ook van andere campagnes)
if (item.properties && item.properties._gwp === 'true') continue;
if (tags.includes(tag)) tagCounts[tag] += item.quantity;

        }
      }
    }

    // Verwerk per giftVariantId groep
    var needsReload = false;
    for (var giftVariantId in giftMap) {
      var group = giftMap[giftVariantId];
      var campaigns = group.campaigns;

      // Check of gift in cart zit
      var giftInCart = null;
      for (var k = 0; k < cart.items.length; k++) {
        var cartItem = cart.items[k];
        if (String(cartItem.variant_id) === giftVariantId &&
            cartItem.properties && cartItem.properties._gwp === 'true') {
          giftInCart = cartItem;
        }
      }
      var currentGiftQty = giftInCart ? giftInCart.quantity : 0;

      // Check of minimaal 1 campagne triggered
      var anyTriggered = false;
      for (var c2 = 0; c2 < campaigns.length; c2++) {
        var minRequired = campaigns[c2].minTaggedCount || 1;
        if ((tagCounts[campaigns[c2].tag] || 0) >= minRequired) {
          anyTriggered = true;
          break;
        }
      }

      var giftAvailable = await gwpIsGiftAvailable(group.giftHandle, giftVariantId);

      if (!giftAvailable) {
        if (currentGiftQty > 0) {
          await gwpRemoveFromCart(giftVariantId);
          needsReload = true;
        }
        continue;
      }

      if (anyTriggered && currentGiftQty === 0) {
  await gwpAddToCart(giftVariantId);
  needsReload = true;
} else if (anyTriggered && currentGiftQty > 1) {
  // Teveel cadeaus in cart — verwijder alles en voeg 1 toe
  await gwpRemoveFromCart(giftVariantId);
  await gwpAddToCart(giftVariantId);
  needsReload = true;
} else if (!anyTriggered && currentGiftQty > 0) {
  await gwpRemoveFromCart(giftVariantId);
  needsReload = true;
}

    }

    

    if (needsReload) {
      location.reload();
      return;
    }

  } catch(e) { console.error('GWP error:', e); }

  gwpRunning = false;
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateGWP, 800);
});

document.addEventListener('cart:updated', function() { gwpRunning = false; updateGWP(); });
document.addEventListener('cart:refresh', function() { gwpRunning = false; updateGWP(); });

var _fetch = window.fetch;
window.fetch = function() {
  var args = arguments;
  return _fetch.apply(this, args).then(function(res) {
    if (gwpFetching) return res;
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      setTimeout(function() { gwpRunning = false; updateGWP(); }, 300);
    }
    return res;
  });
};

// Productpagina badge voorraad check
(function() {
  GWP_CAMPAIGNS.forEach(function(campaign) {
    if (!campaign.active || !campaign.giftHandle) return;
    var selector = '.overlay-gwp-' + campaign.tag.replace('gwp-', '');
    var el = document.querySelector(selector);
    if (!el) return;
    fetch('/products/' + campaign.giftHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var available = p.variants.some(function(v) {
          return String(v.id) === String(campaign.giftVariantId) && v.available;
        });
        if (!available) el.style.display = 'none';
      });
  });
})();
